var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "40px",
    viewBox: "0 -960 960 960",
    width: "40px",
    fill: "#e8eaed",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80-688.67v-84.66q0-26.34 19.83-46.5Q119.67-840 146.67-840h666.66q26.34 0 46.5 20.17Q880-799.67 880-773.33v84.66h-66.67v-84.66H146.67v84.66H80ZM326.67-120v-80h-180q-27 0-46.84-20.17Q80-240.33 80-266.67v-88.66h66.67v88.66h666.66v-88.66H880v88.66q0 26.34-20.17 46.5Q839.67-200 813.33-200h-180v80H326.67ZM480-522Zm-306.67 2 113.34-113.33L240-680 80-520l160 160 46.67-46.67L173.33-520Zm613.34 0L673.33-406.67 720-360l160-160-160-160-46.67 46.67L786.67-520Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.62fb40de16d7d57a5839e1fef0795ea7.svg";
export { ForwardRef as ReactComponent };